module.exports = __webpack_public_path__ + "img/rugby-category-icon-red.48f06ae7.png";